import React, {Component} from "react";
import BorderedRadioInput from "../radio-input/BorderedRadioInput";
import EnumTimeZone from "../../enums/EnumTimeZone";
import {noop} from "lodash-es";
import PropTypes from "prop-types";

class TimeZoneSelector extends Component {

    static defaultProps = {
        options: EnumTimeZone.toArray(),
        value: null,
        onChange: noop
    };

    static propTypes = {
        options: PropTypes.array, // Array of Enum Object
        value: PropTypes.string,
        onChange: PropTypes.func
    };

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <BorderedRadioInput
                values={this.props.options}
                selected={this.props.value}
                onSelect={value => this.props.onChange(value)}
            />
        )
    }
}

export default TimeZoneSelector;